<template>
	<div class="container">
		<!-- 新闻动态 -->
		<div class="companyBox">
		  <div class="searchTitleBox">
			  <div class="searchTitletext">{{$t('home.title2')}}</div>
			  <div class="searchBoxRight">
				  <!-- <div class="searchRow">
					  <div class="searchRowLable">年份:</div>
					  <el-select class="searchSelect" v-model="search.year" placeholder="选择年份">
						<el-option
						  v-for="item in options"
						  :key="item.value"
						  :label="item.label"
						  :value="item.value">
						</el-option>
					  </el-select>
				  </div> -->
				  <div class="searchInputBox">
				  	<el-input class="searchInput" :placeholder="$t('home.searchTips')" v-model="search.keywords">
				  		<i slot="prefix" class="el-input__icon el-icon-search"></i>
				  	</el-input>
				  	<el-button class="searchBtn" type="primary" round @click="searchClick">{{$t('home.searchBtn')}}</el-button>
				  </div>
			  </div>
		  </div>
		  <!--  -->
		  <div class="newsListBox">
			  <el-row :gutter="10">
				<el-col :xs="24" :sm="18" :md="18">
					<div class="newsList_Left">
					  <div class="newsList" v-for="item,index in newsData" v-if="index < 8" @click="goDetailPage(item.id)">
						  <el-col :xs="5" :sm="6" :md="6" :lg="5" :xl="4">
							  <div class="newsDate">{{item.create_time}}</div>
						  </el-col>
						  <el-col :xs="19" :sm="18" :md="18":lg="19" :xl="20">
							  <div class="newsTitle">{{item.title}}</div>
						  </el-col>
					  </div>
					</div>
				</el-col>
				<el-col :xs="24" :sm="6" :md="6">
					<div class="newsList_Right">
						<div class="rightNewsList" v-for="item,index in newsData" v-if="index > 8" @click="goDetailPage(item.id)">
							<el-image
							  class="rightNewsList_img"
							  :src="item.pic"
							  fit="cover">
							</el-image>
							<div class="rightNewsText">{{item.title}}</div>
						</div>	  
					</div>
				</el-col>
			  </el-row>
		  </div>
		  <!-- 分页 -->
		  <div class="paginationBox" v-if="search.totalPages > 0">
		  	<el-pagination background layout="prev, pager, next" 
		  	:pager-count="5"
		  	:current-page="search.page"
		  	:total="search.totalPages"@current-change="currentPageChange"></el-pagination>
		  </div>
		</div>
	</div>
</template>

<script>
	import { localStorage } from '@/utils/storage.js'
	import { formatTimeNum } from '@/utils'
	import * as home from '@/api/home'
		
	export default {
	  name: 'partyBuilding',
	  data() {
		return {
			// 
			options: [{
			  value: '2022',
			  label: '2022'
			}, {
			  value: '2021',
			  label: '2021'
			}, {
			  value: '2020',
			  label: '2020'
			}, {
			  value: '2019',
			  label: '2019'
			}, {
			  value: '2018',
			  label: '2018'
			}],
			search: {
				// year: '2022',
				keywords: '',
				totalPages: 0,
				page: 1,
				size: 12,
			},
			// 
			companyGutter: 20, //公司简介间隔
			// 数据
			newsData: [],
		};
	  },
	  mounted() {
		this.resetScrollTop();
		// 监听屏幕变化
	  	window.onresize = () => {   //屏幕尺寸变化就重新赋值
		  return (() => {
			if(document.body.clientWidth < 768){
				this.companyGutter = 0
			}else{
				this.companyGutter = 20
			}
		  })()
		}
		this.getNewsData();
	  },
	  methods:{
	    resetScrollTop(){
		  this.$nextTick(()=>{
			  document.getElementById("pageMain").scrollTop = 0
		  })
	    },
		// 搜索
		searchClick(){
		  this.search.page = 1
		  this.getNewsData();
		},
		// 获取党建要闻
		getNewsData(){
			const that = this;
			const para = this.search
			const lang = localStorage.get('language')
			home.party_building(para).then(res => {
			 if(res.code == 0){
				let data = res.data.data
				for (let item of data) {
					if(lang == 'en'){
						item.create_time = formatTimeNum(item.create_time,'Y-M-D')
					}else{
						item.create_time = formatTimeNum(item.create_time,'Y年M月D日')
					}
				}
				that.newsData = data
				that.search.currentPage = res.data.currentPage  //当前页数
				that.search.totalPages = res.data.totalPages //总页数
			 }
			}).catch((res) => {
			  ;
			})
		},
		// 分页
		currentPageChange(e){
			;
			this.search.page = e
			this.getNewsData();
		},
		// 查看详情
		goDetailPage(id){
			;
			this.$router.push({
				path:'/partyBuildingDetail',
				query: { id: id },
			})
		},
		
	  }
	  
	}
</script>
<style>
	.searchInput .el-input__inner{
		border-radius: 80px;
		padding-left: 40px;
	}
	.searchInput .el-input__prefix{
		left: 10px;
	}
</style>
<style scoped>
	.companyBox{
		width: 100%;
		background: #ffffff;
		padding: 20px 0 30px;
	}
	/* 标题搜索 */
	.searchTitleBox{
		width: 90%;
		max-width: 1100px;
		box-sizing: border-box;
		padding: 20px 10px;
		margin: 0 auto;
		display: flex;
		align-items: center;
	}
	.searchTitletext{
		font-size: 28px;
		font-weight: bold;
		color: #015a9c;
	}
	.searchBoxRight{
		flex-grow: 1;
		display: flex;
		align-items: center;
		justify-content: flex-end;
	}
	.searchRow{
		display: flex;
		align-items: center;
		margin-right: 20px;
	}
	.searchRowLable{
		width: 50px;
		padding-right: 10px;
		text-align: right;
		font-size: 15px;
		color: #787b8a;
	}
	.searchRow /deep/ .el-input__inner{
		border-radius: 80px;
		width: 150px;
	}
	.searchInputBox{
		display: flex;
		align-items: center;
	}
	.searchInput{
		width: 200px;
		border-radius: 80px;
		margin-right: 20px;
	}
	.searchBtn{
		padding: 10px 30px;
		font-size: 15px;
	}
	
	/*  */
	.newsListBox{
		width: 90%;
		max-width: 1100px;
		margin: 0 auto;
		/* display: flex;
		align-items: center; */
		padding-top: 10px;
	}
	.newsList_Left{
		/* width: calc(100% - 350px); */
		width: 100%;
		margin-bottom: 10px;
	}
	.newsList{
		width: 100%;
		padding: 15px 0;
		display: flex;
		align-items: center;
		cursor: pointer;
	}
	.newsDate{
		width: 120px;
		font-size: 14px;
		color: #787b8a;
		margin-right: 40px;
	}
	.newsTitle{
		 /* width: calc(100% - 160px); */
		width: 100%;
		display: -webkit-box;
		overflow: hidden;
		/*! autoprefixer: off; */     
		-webkit-box-orient: vertical;
		-webkit-line-clamp: 2;
	
	}
	.newsList_Right{
		width: 100%;
	}
	.rightNewsList{
		width: 100%;
		margin: 30px 0;
		cursor: pointer;
	}
	.rightNewsList_img{
		width: 100%;
		height: 150px;
	}
	.rightNewsText{
		padding: 10px 0;
		font-size: 16px;
		color: #333333;
		display: -webkit-box;
		overflow: hidden;
		/*! autoprefixer: off; */     
		-webkit-box-orient: vertical;
		-webkit-line-clamp: 2;
	}
	/* 分页 */
	.paginationBox{
		width: 100%;
		box-sizing: border-box;
		padding: 40px 10px 20px;
		display: flex;
		align-items: center;
		justify-content: center;
	}
	
	
	
	/* 响应式样式 */
	@media only screen and (max-width: 768px) {
	  /* 标题搜索 */
	  .searchTitleBox{
	  	width: 90%;
	  	box-sizing: border-box;
	  	padding: 0 10px 10px;
	  	display: block;
	  }
	  .searchBoxRight{
	  	display: block;
		margin-top: 20px;
	  }
	  .searchRow{
		  margin-bottom: 10px;
	  }
	  .rightNewsList_img{
	  	  height: auto
	  }
	}
	@media screen and (min-width: 768px) and (max-width: 992px){
		/* 标题搜索 */
		.searchTitleBox{
			width: 90%;
			box-sizing: border-box;
			padding: 0 10px 10px;
			display: block;
		}
		.searchBoxRight{
			margin-top: 20px;
		}
	}
	
	@media screen and (min-width: 992px) {  }
	
	@media screen and (min-width: 1200px) {  }
	
	@media screen and (min-width: 1400px) {  }
	
	@media screen and (min-width: 1920px) {  }
</style>